import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
           
            cf.registerFilter("nro_item", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nro_item + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase()) || (item.nro_item + "")
                            .toLowerCase()
                            .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nombre_unidad", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombre_unidad + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("cargo", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.cargo + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("sueldo", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.sueldo + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("puesto", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.puesto + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
       
            return cf.runFilters();
        },

        filterNroItem(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_item: val
            });
        },
        filterNombreUnidad(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: val
            });
        },
        filterCargo(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                cargo: val
            });
        },
        filterSueldo(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                sueldo: val
            });
        },
        filterPuesto(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                puesto: val
            });
        },
     
        recargar() {
            this.form = {};
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_item: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                cargo: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                sueldo: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                puesto: ""
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/item_cargo_y_puesto/mixins/filtrosItems.js